import baseApi from "./base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigResponse } from "./types/config"
import { GetCitiesResponse } from "./types/city"
import { GetBranchesRequest, GetBranchesResponse } from "./types/branch"
import { CreateBranchRequest, CreateBranchResponse } from "./types/createBranch"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => {
    return ({
      getTokenByTckn1: builder.mutation<BaseResponse, string>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body,
            functionCode: "SPE0005",
            NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
            TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
          },
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      getConfig: builder.mutation<GetConfigResponse, string>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            configKey: body,
            NextTransactionUrl: "Facebook/SMPUConfig/GetConfig1",
            TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
          },
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            TokenSessionId: body.TokenSessionId,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/GetCaptcha1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            TokenSessionId: body.TokenSessionId,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/GetCaptcha1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      apply: builder.mutation<ApplyResponse, ApplyRequest>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            cepTel: body.cepTel,
            dogumYil: body.dogumYil,
            dogumAy: body.dogumAy,
            dogumGun: body.dogumGun,
            appCode: "SPE0005",
            captcha: body.captcha,
            kvkk: body.kvkk,
            cid: body.cid,
            TokenSessionId: body.TokenSessionId,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/ApplicationInit1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            TokenSessionId: body.TokenSessionId,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/ResendOtp1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      apply2: builder.mutation<Apply2Response, Apply2Request>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            sifreEnc: body.otp,
            sifreNo: body.otpId,
            appCode: "SPE0005",
            TokenSessionId: body.TokenSessionId,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/VerifyOtp1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      apply3: builder.mutation<Apply3Response, Apply3Request>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            TokenSessionId: body.TokenSessionId,
            cuzdanSeri: body.kimlikSeriSiraNo.slice(0, 3),
            cuzdanSira: body.kimlikSeriSiraNo.slice(3, 9),
            appCode: "SPE0005",
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/VerifyIdentity1",
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      getCities: builder.mutation<GetCitiesResponse, string>({
        query: (body) => ({
          url: "",
          method: "POST",
          body: {
            NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
            TokenSessionId: body
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      getBranches: builder.mutation<GetBranchesResponse, GetBranchesRequest>({
        query: (body) => ({
          url: "",
          method: "POST",
          body: {
            ilKodu: body.cityId,
            NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/BranchesList1",
            TokenSessionId: body.TokenSessionId
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      }),
      createBranch: builder.mutation<CreateBranchResponse, CreateBranchRequest>({
        query: (body) => ({
          url: "/",
          method: "POST",
          body: {
            tckn: body.tckn,
            sube: body.sube,
            NextTransactionUrl: "Facebook/EmekliMaasTasimaLead/CreateBranchLead1",
            TokenSessionId: body.TokenSessionId,
          }
        }),
        transformResponse: (response: string) => JSON.parse(response)
      })
    })
  }
})

export const { useGetTokenByTckn1Mutation, useGetConfigMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, useGetCitiesMutation, useGetBranchesMutation, useCreateBranchMutation } = api

export default api
